import React, { useEffect, useState } from 'react';
import PropTypes from "prop-types";
import style from './EuleriagymFunctionalEvaluationResults.module.sass';
import Select from '../Select/Select';
import EuleriagymFunctionalSitToStandResult from './EuleriagymFunctionalSitToStandResult';


function EuleriagymFunctionalEvaluationResults(props) {
  const {
    color,
    exerciseName,
    results,
    sideChooser
  } = props;

  const [selectedResult, setSelectedResult] = useState({});

  useEffect(() => {
    setSelectedResult(optionsForSelect()[0]);
  }, [])

  const optionsForSelect = () => {
    return results.map((result, index) => {

      const label = result.modality[0].label

      return {
        value: index,
        label: `${index + 1}. ${label}`,
        key: index,
        result: result
      }
    })
  }



  return (
    <div>
      <div className={style.resultSelectionTile}>
        <div>
          <div className={style.exerciseName} style={{ color: color }}>
            {exerciseName}
          </div>
        </div>

        <div className={style.resultsSelect}>
          <Select
            options={optionsForSelect()}
            searchable={false}
            selectedOption={selectedResult.label}
            setOption={setSelectedResult}
          />
        </div>
      </div>
      {selectedResult.result &&
        <div className={style.resultContainer}>
          <EuleriagymFunctionalSitToStandResult
            result={selectedResult.result}
            color={color}
          />
        </div>
      }
    </div>
  )
}

EuleriagymFunctionalEvaluationResults.propTypes = {
  color: PropTypes.string,
  exerciseName: PropTypes.string,
  results: PropTypes.array,
  sideChooser: PropTypes.object
}

export default EuleriagymFunctionalEvaluationResults;